import React from "react";

import type {
  CustomerConfig,
  Environment,
} from "../../types";

type Props = {
  customersLoading: boolean;
  customersError?: string | null;

  selectedCustomer?: CustomerConfig | null;

  environment: Environment;
  setEnvironment: React.Dispatch<
    React.SetStateAction<Environment>
  >;

  filteredCustomers: CustomerConfig[];

  selectCustomer: (customer: CustomerConfig) => void;
};

export default function CustomerInspector({
  customersLoading,
  customersError,
  selectedCustomer,
  environment,
  setEnvironment,
  filteredCustomers,
  selectCustomer,
}: Props) {
  return (
    <>
      <div className="rounded-xl border border-violet-500/20 bg-violet-500/10 p-4">
        <div className="text-sm font-semibold text-slate-950 dark:text-white">
          Customer context
        </div>

        <p className="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-400">
          Kies de klant en omgeving die door de volgende JDX-acties gebruikt worden.
        </p>
      </div>

      <div className="rounded-xl border border-slate-200 bg-slate-50/80 p-4 dark:border-white/10 dark:bg-slate-950/60">
        <label className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-400">
          Environment
        </label>

        <select
          value={environment}
          onChange={(event) =>
            setEnvironment(event.target.value as Environment)
          }
          className="mt-2 w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none transition focus:border-orange-400 dark:border-white/10 dark:bg-slate-900 dark:text-white"
        >
          <option value="acc">Acceptance</option>
          <option value="prod">Production</option>
          <option value="dev">Development</option>
        </select>
      </div>

      <div className="rounded-xl border border-slate-200 bg-slate-50/80 p-4 dark:border-white/10 dark:bg-slate-950/60">
        <label className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-400">
          Customer
        </label>

        {customersLoading && (
          <div className="mt-2 rounded-xl bg-slate-100 px-3 py-2 text-sm text-slate-500 dark:bg-white/10 dark:text-slate-400">
            Loading customers...
          </div>
        )}

        {customersError && (
          <div className="mt-2 rounded-xl bg-red-500/10 px-3 py-2 text-sm text-red-600 dark:text-red-300">
            {customersError}
          </div>
        )}

        <select
          value={selectedCustomer?.customerId || ""}
          onChange={(event) => {
            const customer = filteredCustomers.find(
              (item) =>
                item.customerId === event.target.value
            );

            if (customer) {
              selectCustomer(customer);
            }
          }}
          className="mt-2 w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none transition focus:border-orange-400 dark:border-white/10 dark:bg-slate-900 dark:text-white"
        >
          <option value="">
            Select customer...
          </option>

          {filteredCustomers.map((customer) => (
            <option
              key={
                customer.customerKey ||
                customer.customerId
              }
              value={customer.customerId}
            >
              {customer.customerName} ·{" "}
              {customer.entityCode ||
                customer.entity ||
                "No entity"}
            </option>
          ))}
        </select>

        {selectedCustomer && (
          <div className="mt-4 grid grid-cols-2 gap-2 text-xs">
            <div className="rounded-lg bg-white px-3 py-2 text-slate-600 dark:bg-slate-900 dark:text-slate-300">
              Entity:{" "}
              <span className="font-semibold">
                {selectedCustomer.entityCode ||
                  selectedCustomer.entity ||
                  "-"}
              </span>
            </div>

            <div className="rounded-lg bg-white px-3 py-2 text-slate-600 dark:bg-slate-900 dark:text-slate-300">
              Target:{" "}
              <span className="font-semibold">
                {selectedCustomer.targetTable ||
                  "-"}
              </span>
            </div>
          </div>
        )}
      </div>
    </>
  );
}